module.exports = __webpack_public_path__ + "img/bk_17_app.0e9478f7.png";